import { ComponentPropsWithoutRef, FC, ReactNode, Ref, useCallback, useRef } from 'react';
import classNames from 'classnames';

import { useIsScrollable } from '../../../useIsScrollable';
import { useScrollEdges } from '../../../useScrollEdges';
import styles from './ModalBody.module.css';

export type ModalBodyProps = {
  children?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>;

/** Тело модалки со скроллом. */
const ModalBody: FC<ModalBodyProps> = ({ children, className, ref, ...rest }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { atTop, atBottom } = useScrollEdges(scrollRef);
  const isScrollable = useIsScrollable(scrollRef);
  const scrollableProps = isScrollable ? { tabIndex: 0 } : undefined;

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      scrollRef.current = node;

      if (typeof ref === 'function') ref(node);
      else if (ref) Object.assign(ref, { current: node });
    },
    [ref]
  );

  return (
    <div
      ref={setRef}
      {...scrollableProps}
      {...rest}
      data-scroll-at-top={atTop}
      data-scroll-at-bottom={atBottom}
      className={classNames(styles.body, className)}>
      {children}
    </div>
  );
};

export default ModalBody;
